<template>
    <hts-drawer
        v-model="visible"
        :submit="handleSubmitFormEditTypeVehicle"
        :title="$t('labels.editVehicleCategory')"
        :undo-enable="true"
        :rules="rulesEditVehicleCategory"
        @close="closeOverSide"
        @undo="undo()">
        <div class="hts-vehicles-ignore-add-vehicle">
            <div class="hts-vehicles-ignore-add-vehicle__container-body">
                <hts-card :title="$t('labels.generalInformation')">
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.name"
                        :label="$t('labels.vehicleModule.category.categoryName')"
                        :color="props.color"
                        required
                        name="vehicleModule.category.categoryName"
                        prop="vehicleModule.category.categoryName" />
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.from"
                        :label="$t('labels.fromKg')"
                        required
                        :color="props.color"
                        type="number"
                        disabled
                        name="fromKg"
                        prop="fromKg" />
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.to"
                        :label="$t('labels.comeFirstKg')"
                        :color="props.color"
                        type="number"
                        name="comeFirstKg"
                        prop="toKg" />
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.wheelNumber"
                        :label="$t('labels.vehicleModule.category.wheelNumber')"
                        :color="props.color"
                        required
                        type="number"
                        name="vehicleModule.category.wheelNumber"
                        prop="vehicleModule.category.wheelNumber" />
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.priceTires"
                        :label="$t('labels.vehicleModule.category.priceTires')"
                        required
                        :color="props.color"
                        type="number"
                        name="vehicleModule.category.priceTires"
                        prop="vehicleModule.category.priceTires" />
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.depreciationTires"
                        :label="$t('labels.vehicleModule.category.depreciationTires')"
                        required
                        :color="props.color"
                        type="number"
                        name="vehicleModule.category.depreciationTires"
                        prop="vehicleModule.category.depreciationTires" />
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.repairingPrice"
                        :label="$t('labels.vehicleModule.repairingPrice')"
                        required
                        :color="props.color"
                        type="number"
                        name="vehicleModule.repairingPrice"
                        prop="vehicleModule.repairingPrice" />
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.liquidationValue"
                        :label="$t('labels.liquidationValue')"
                        required
                        :color="props.color"
                        type="number"
                        name="liquidationValue"
                        prop="liquidationValue" />
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.oilMaterialAssumption"
                        :label="$t('labels.oilMaterialAssumption')"
                        required
                        :color="props.color"
                        type="number"
                        name="oilMaterialAssumption"
                        prop="oilMaterialAssumption" />
                    <hts-form-input
                        v-model="dataFormEditVehicleCategory.description"
                        :label="$t('labels.description')"
                        :color="props.color"
                        name="description"
                        prop="description" />
                </hts-card>
            </div>
        </div>
        <hts-modal
            :show="confirmEditTypeVehicle"
            :title="$t('labels.confirmEditTypeVehicle')"
            :content="$t('labels.contentEditTypeVehicle')"
            type="confirm"
            @hide="cancelEditTypeVehicle"
            @confirm="submitFormEditTypeVehicle" />
    </hts-drawer>
</template>

<script setup lang="ts">
import form from '../imports/form'
import { $urlSystem } from '#imports'
const { rules } = form
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  infoTypeVehicle: {
    type: Object
  }
})

const emits = defineEmits(['close', 'refreshTables'])

const visible = ref(false)
const confirmEditTypeVehicle = ref(false)
const openEditCategory = () => {
  visible.value = true
}
defineExpose({
  openEditCategory
})
const closeOverSide = () => {
  visible.value = false
}

const dataFormEditVehicleCategory = reactive({ ...form.initVehicleCategory })

watch(props, () => {
  _init()
})

const _init = () => {
  Object.assign(dataFormEditVehicleCategory, { ...props.infoTypeVehicle })
}
const undo = () => {
  _init()
}

const handleSubmitFormEditTypeVehicle = () => {
  confirmEditTypeVehicle.value = true
}

const submitFormEditTypeVehicle = () => {
  $api($urlSystem.vehicle.category.edit, { uriParams: { ID: props.infoTypeVehicle?._id }, body: { ...dataFormEditVehicleCategory } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      process.client && $toast().success($t('labels.editTypeVehicleSuccess'))
      emits('refreshTables')
      emits('close')
    }
    visible.value = false
    confirmEditTypeVehicle.value = false
  })
}
const cancelEditTypeVehicle = () => {
  confirmEditTypeVehicle.value = false
  process.client && $toast().error($t('labels.editTypeVehicleError'))
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

const rulesEditVehicleCategory = computed(() => {
  const data = rules.addVehicleCategory
  if (typeof dataFormEditVehicleCategory.from === 'number') {
    data.toKg = `integer|min_value:${dataFormEditVehicleCategory.from + 1}`
  }
  return data
})
</script>
